exports.get = function (state, id) {
  return state.dal.funders.get(state, id)
}
